export default __webpack_public_path__ + "static/media/7SG130.92caa22e.jpg";